import React, { Dispatch, SetStateAction } from 'react';
import {
  StyleSheet, View, Text, TouchableOpacity, ScrollView, Pressable, TextInput,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Colors from '../../../../../constants/Colors';
import { assetName } from '../../../data';
import isMobile from '../../../../../components/IsMobile';
import Style from '../../../../../constants/Style';
import { AssetInstance } from '../../../../../constants/Types';
import { PressableState } from '../../../../../components/PressableStyled';

interface AssetDropdownProps {
  selectedAssetId: string,
  setAssetDropdownShown: Dispatch<SetStateAction<boolean>>,
  assets: AssetInstance[],
  assetDropdownShown: boolean,
  assetSearchValue: string,
  setAssetSearchValue: Dispatch<SetStateAction<string>>,
  setSelectedAssetId: Dispatch<SetStateAction<string>>,
  setSelectedAssetName?: Dispatch<SetStateAction<string>>,
  closeOtherDropdowns: () => void,
}

const AssetDropdown = ({
  selectedAssetId, setAssetDropdownShown, assets, assetDropdownShown, assetSearchValue,
  setAssetSearchValue, setSelectedAssetId, setSelectedAssetName, closeOtherDropdowns,
}: AssetDropdownProps) => <View style={styles.container}>
    <View style={styles.titleContainer}>
      <Text style={styles.filterText}>{'Asset Name'}</Text>
    </View>
    <>
      {!assetDropdownShown && <TouchableOpacity
        style={[Style.dropdown, { zIndex: 2 }]}
        onPress={() => {
          setAssetDropdownShown(!assetDropdownShown);
          closeOtherDropdowns();
        }}
      >
        <View style={styles.header}>
          <>
            {selectedAssetId?.length > 0 ? <Text
              numberOfLines={1}
              style={[styles.chooseAssigneeText, { color: 'black', marginEnd: 26 }]}
            >
              {assetName(selectedAssetId, assets)}
            </Text> : <Text style={styles.chooseAssigneeText}>{'Choose Asset'}</Text>}
            <View style={styles.iconContainer}>
              <FontAwesome
                size={20}
                style={styles.icon}
                name={'angle-down'}
              />
            </View>
          </>
        </View>
      </TouchableOpacity>}
      {assetDropdownShown && <View style={[Style.dropdown, { zIndex: 2 }]}>
        <TextInput
          placeholder='Search'
          style={[{ marginStart: 8 }, !isMobile && { outlineWidth: 0 }]}
          placeholderTextColor={Colors.light.hereworksPrimaryGrey700}
          onChangeText={setAssetSearchValue}
        />
        <TouchableOpacity
          style={{ flex: 1, alignItems: 'flex-end' }}
          onPress={() => {
            // analytics('Close asset dropdown');
            setAssetSearchValue('');
            setAssetDropdownShown(false);
            closeOtherDropdowns();
          }}
        >
          <FontAwesome
            size={20}
            style={styles.icon}
            name={'angle-up'}
          />
        </TouchableOpacity>
      </View>}
    </>
    {assetDropdownShown && <ScrollView
      style={styles.dropdownView}
      nestedScrollEnabled
      testID='assets-list'
    >
      <Pressable
        onPress={() => {
          setSelectedAssetId('');
          setSelectedAssetName?.('');
          setAssetSearchValue('');
          setAssetDropdownShown(false);
          closeOtherDropdowns();
        }}
        style={({ hovered }: PressableState) => [
          styles.button, hovered && { backgroundColor: Colors.light.hereworksWhite200 },
        ]}
      >
        <Text style={styles.filterText}>ALL ASSETS</Text>
      </Pressable>
      {assets.map((asset: AssetInstance, key) => (asset.name?.toLocaleLowerCase()
        .includes(assetSearchValue.toLocaleLowerCase()) ? <Pressable
          key={key}
          onPress={() => {
            setSelectedAssetId(asset.id);
            setSelectedAssetName?.(asset.name);
            setAssetSearchValue('');
            setAssetDropdownShown(false);
            closeOtherDropdowns();
          }}
          style={({ hovered }: PressableState) => [
            styles.button,
            hovered && { backgroundColor: Colors.light.hereworksWhite200 },
            selectedAssetId === asset.id && styles.selected,
          ]}
        >
        <Text style={styles.filterText}>{asset.name}</Text>
      </Pressable> : null))}
    </ScrollView>}
  </View>;

const styles = StyleSheet.create({
  button: {
    paddingStart: 10,
    paddingVertical: 10,
    borderRadius: 4,
    marginVertical: 4,
  },
  container: {
    marginTop: 13,
  },
  titleContainer: {
    height: 36,
    justifyContent: 'center',
  },
  header: {
    flexDirection: 'row',
    flex: 2,
    alignItems: 'center',
  },
  filterText: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 18,
    marginBottom: 4,
    marginEnd: 20,
    color: Colors.light.hereworksBlack600,
  },
  chooseAssigneeText: {
    color: Colors.light.hereworksPrimaryGrey800,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    marginStart: 10,
  },
  selected: {
    borderColor: Colors.light.hereworksBlue400,
    borderWidth: 1,
  },
  iconContainer: {
    flex: 1,
    alignItems: 'flex-end',
  },
  dropdownView: {
    width: '100%',
    maxHeight: 200,
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    marginTop: 4,
  },
  icon: {
    color: Colors.light.hereworksBlue500,
    marginEnd: 12,
  },
});

export default AssetDropdown;
